export { HeaderSkeleton } from './HeaderSkeleton';



// WEBPACK FOOTER //
// ./app/common/components/HeaderSkeleton/index.ts